import { useEffect, useState } from "react";
import { DEFAULT_PX_PER_MM, loadPxPerMm } from "@/lib/screen-calibration";

/**
 * The screen's pixels-per-millimetre, remembered between visits.
 *
 * Starts at the CSS-spec value and swaps to the stored one after mount, so the server
 * and the first client render agree. Lives here rather than beside the ruler so the
 * ruler and the life-stage diagram can share one live value.
 */
export function useCalibration(): [number, (value: number) => void] {
  const [pxPerMm, setPxPerMm] = useState(DEFAULT_PX_PER_MM);

  useEffect(() => {
    const stored = loadPxPerMm();
    if (stored !== null) setPxPerMm(stored);
  }, []);

  return [pxPerMm, setPxPerMm];
}
